import { environment } from './../../../environments/environment';
export const GATEWAY_URL = environment.API_URL + '/gateway';
export const USER_API = GATEWAY_URL + '/User';
export const AUTHEN_URL = environment.TRUE_URL + '/api/authenticate';
export const URL_CDN_UPLOAD = environment.URL_CDN_UPLOAD;
export const WEBSITE_URL = GATEWAY_URL + '/website';
export const CHANGE_PW_URL = environment.CHANGE_PWD_URL;
